import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import Card from 'components/Card/Card.jsx';
import Hidden from '@material-ui/core/Hidden';

// core components
import RecentActivity from 'components/RecentActivity';
import GridContainer from 'components/Grid/GridContainer.jsx';
import MessageInfo from 'components/MessageInfo';
import TabsForUserTrackProfile from 'components/TabsForUserTrackProfile';
import GridItem from 'components/Grid/GridItem.jsx';
import LoaderWhite from 'components/LoaderWhite';
import Style from 'assets/jss/material-dashboard-pro-react/views/profileStyle.jsx';
import { updateUserData } from 'store/actions/userActions';
import Store from 'services/StoreService';
import DefaultProfile from 'assets/img/default-avatar.png';
import PublicProfileDetails from 'components/PublicProfileDetails';
import buildAvatarPath from 'utils/buildAvatarPath';

const PublicProfile = ({ id, uid, classes, following, updateUserData }) => {
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const data = await Store.getUserData(id);
    setProfile(data || {});
  };

  const toggleFollowUser = async () => {
    const list = following.includes(id)
      ? following.filter((e) => e !== id)
      : following.concat(id);
    // Persist change in the database
    await Store.updateUser(uid, { following: list });
    // Persist change in the app state
    updateUserData({ following: list });
  };

  if (!profile) return <LoaderWhite />;

  if (!profile.uid) return <MessageInfo text='Unknown user' />;

  const {
    bio,
    photoURL,
    favoriteSongs,
    recentActivity,
    avatar,
    firstName,
    lastName,
    username,
    displayName,
    socialAccounts,
  } = profile;

  const name = displayName || username || `${firstName} ${lastName}`;
  const userAvatar = avatar && buildAvatarPath(avatar);
  const profilePhoto = userAvatar || photoURL || DefaultProfile;

  return (
    <GridContainer>
      <GridItem xs={12}>
        <GridContainer>
          <GridItem
            style={{
              margin: '0px -30px',
              width: '117%',
            }}
          >
            <Card
              profile
              style={{
                paddingBottom: '10px',
                borderRadius: '20px 20px 0px 0px',
              }}
            >
                <PublicProfileDetails
                  name={name}
                  userBio={bio}
                  isFollowed={following.includes(id)}
                  profilePhoto={profilePhoto}
                  toggleFollow={toggleFollowUser}
                  socialAccounts={socialAccounts}
                />
            </Card>
            <div style={{ margin: '-30px 0px -30px 0px' }}>
              {!!recentActivity && recentActivity.length > 1 && (
                <RecentActivity list={recentActivity} />
              )}
            </div>
            <div style={{ background: '#EDEEFB', paddingBottom: '120px' }}>
              <TabsForUserTrackProfile favoriteSongs={favoriteSongs} />
            </div>
          </GridItem>
        </GridContainer>
      </GridItem>
    </GridContainer>
  );
};

PublicProfile.defaultProps = {
  following: [],
};

export default compose(
  connect(
    ({ user }, { match }) => ({
      uid: user.uid,
      id: match.params.id,
      following: user.following,
    }),
    { updateUserData }
  ),
  withStyles(Style)
)(PublicProfile);
